import { all } from 'redux-saga/effects';
import { watchGetUser, watchUpdateUser } from '../saga/userSaga';
import { watchGetBlogs, watchGetSingleBlog } from '../saga/blogSaga';
import { watchAddDroneManufacturer, watchAddInstitute, watchGetInstitutes, watchGetSingleInstitutes } from '../saga/instituteSaga';
import { watchVerifyPhone } from '../saga/otpSaga';
import { watchGetCourses, watchGetSingleCourses } from '../saga/courseSaga';
import { watchGetDroneCategory } from './droneCategorySaga';
import { watchGetDroneJobs, watchGetSingleDroneJob } from './droneJobsSaga';
import { watchGetWorkshops } from "../saga/workshopSaga"; // ✅ Import this

export default function* rootSaga() {
  yield all([
    watchGetUser(),
    watchUpdateUser(),
    watchGetBlogs(),
    watchAddInstitute(),
    watchGetInstitutes(),
    watchVerifyPhone(),
    watchGetSingleInstitutes(),
    watchGetCourses(),
    watchGetSingleCourses(),
    watchGetDroneCategory(),
    watchGetSingleBlog(),
    watchGetDroneJobs(),
    watchGetSingleDroneJob(),
    watchAddDroneManufacturer(),
    watchGetWorkshops(),
  ]);
}
